const RemoveContent = ({ product, onRemove, onAddToCart, onClose }) => {
  return (
    <div className="flex flex-col items-center text-center">

      <img
        src={product.image}
        alt={product.name}
        className="w-24 h-24 object-cover rounded-lg mb-4"
      />

      <h3 className="text-xl font-semibold">
        Remove from Wishlist
      </h3>

      <p className="text-gray-500 mt-2 text-sm">
        Are you sure you want to remove this item?
      </p>

      <div className="flex gap-4 mt-6 w-full">
        <button
          onClick={() => {
            onRemove(product);
            onClose();
          }}
          className="flex-1 border py-3 text-sm uppercase font-semibold hover:bg-gray-100 rounded-lg transition"
        >
          REMOVE
        </button>

        {/* <button
          onClick={() => {
            onAddToCart(product, "M");
            onRemove(product);
            onClose();
          }}
          className="flex-1 bg-black text-white py-3 text-sm uppercase font-semibold hover:bg-gray-900 rounded-lg transition"
        >
          MOVE TO CART
        </button> */}
      </div>
    </div>
  );
};

export default RemoveContent